export const configBot = {
  width: "100%",
  height: "100vh",
  floating: false,

  botDelay: 2000,
  headerTitle: "Assesinho",
  recognitionLang: "Pt-br",
  botAvatar: "https://assesi.com.br/equipe/10.png"
};

export const theme = {
  background: "#f5f8fb",
  fontFamily: "Arial, Helvetica, sans-serif",
  headerBgColor: "#333",
  headerFontColor: "#fff",
  headerFontSize: "17px",
  botBubbleColor: "#333",
  botFontColor: "#fff",
  userBubbleColor: "#fff",
  userFontColor: "#4a4a4a"
};
